import { SENSOR_READY_PATHS } from "./config";

export default ({ location }) =>
  SENSOR_READY_PATHS.find(srp => location.pathname.indexOf(srp) === 0) !==
  undefined;
